module.exports = __webpack_public_path__ + "static/media/306b58814864828ba9ad88a281d60583_9e9e9e.cf4523a2.svg";